import { v as bvVar } from 'bv';

import BaseCaptchaService from './base_captcha_service';
import CustomCaptchaService from './custom_captcha_service';
import { GoogleCaptchaService } from './google_captcha_service';

const Service = {
  custom_solution: CustomCaptchaService,
  disabled: BaseCaptchaService,
  google_recaptcha_v3: GoogleCaptchaService,
}[bvVar('captchaStrategy')];

export const captchaService = Service ? new Service() : null;
